import React from "react";
import { ResponsiveContainer, ComposedChart, Area, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { COLORS, fmtRate } from "@/components/simstats/simStatsUtils";

const SERIES = [["activated", "Attivate"], ["migrated", "Migrate out"], ["rate", "Tasso %"]];

const ChartTip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return <div className="rounded-lg border border-border bg-popover px-3 py-2 text-xs shadow-lg space-y-0.5" data-testid="simstats-tooltip">
    <p className="font-semibold">{label}</p>
    <p style={{ color: COLORS.activated }}>Attivate: <strong>{p.activated}</strong></p>
    <p style={{ color: COLORS.migrated }}>Migrate out: <strong>{p.migrated}</strong></p>
    <p style={{ color: COLORS.rate }}>Tasso: <strong>{fmtRate(p.rate)}</strong></p>
  </div>;
};

export const SeriesToggles = ({ show, setShow }) => (
  <div className="flex flex-wrap gap-1.5" data-testid="simstats-series">
    {SERIES.map(([k, l]) => <button key={k} type="button" aria-pressed={show[k]} onClick={() => setShow((s) => ({ ...s, [k]: !s[k] }))} data-testid={`simstats-series-${k}`}
      className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs transition-[opacity,border-color] ${show[k] ? "border-border" : "border-transparent opacity-45"}`}>
      <span className="w-2.5 h-2.5 rounded-sm" style={{ background: COLORS[k] }} />{l}</button>)}
  </div>
);

export const SimStatsChart = ({ series, show }) => {
  if (!show.activated && !show.migrated && !show.rate) return <p className="h-72 grid place-items-center text-sm text-muted-foreground">Scegli almeno una serie da mostrare.</p>;
  return <div className="h-72 w-full" data-testid="simstats-chart">
    <ResponsiveContainer>
      <ComposedChart data={series} margin={{ top: 10, right: 4, left: -14, bottom: 0 }}>
        <defs>
          <linearGradient id="simA" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={COLORS.activated} stopOpacity={0.35} /><stop offset="100%" stopColor={COLORS.activated} stopOpacity={0} /></linearGradient>
          <linearGradient id="simM" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={COLORS.migrated} stopOpacity={0.35} /><stop offset="100%" stopColor={COLORS.migrated} stopOpacity={0} /></linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#1F2937" vertical={false} />
        <XAxis dataKey="label" stroke="#9CA3AF" fontSize={11} tickLine={false} axisLine={false} minTickGap={14} />
        <YAxis yAxisId="n" allowDecimals={false} stroke="#9CA3AF" fontSize={11} tickLine={false} axisLine={false} width={44} />
        {show.rate && <YAxis yAxisId="r" orientation="right" stroke="#9CA3AF" fontSize={11} tickLine={false} axisLine={false} width={44} unit="%" />}
        <Tooltip content={<ChartTip />} cursor={{ stroke: "#374151" }} />
        {show.activated && <Area yAxisId="n" type="monotone" dataKey="activated" stroke={COLORS.activated} strokeWidth={2} fill="url(#simA)" isAnimationActive={false} />}
        {show.migrated && <Area yAxisId="n" type="monotone" dataKey="migrated" stroke={COLORS.migrated} strokeWidth={2} fill="url(#simM)" isAnimationActive={false} />}
        {show.rate && <Line yAxisId="r" type="monotone" dataKey="rate" stroke={COLORS.rate} strokeWidth={2} strokeDasharray="4 4" dot={false} connectNulls isAnimationActive={false} />}
      </ComposedChart>
    </ResponsiveContainer>
  </div>;
};
